import { inject, DependencyContainer } from 'tsyringe'
import Vue from 'vue'
import { ClientOnly } from '~/decorators'
import { containerScoped } from '~/decorators/dependency-container'
import { requestContainerToken } from '~/constants/dependency-injection/tokens'
import { RefType } from '~/models/event/builder'
import HoverEventBuilder from '~/builders/event/HoverEventBuilder'
import WindowWidthResizeEventBuilder from '~/builders/event/WidthResizeEventBuilder'

@ClientOnly
@containerScoped()
/**
 * The proper name for this is 'Event Builder Creator', to be precise, but it would be counter-intuitive to type it as
 * such continuously.
 */
export default class EventBuilder {
  constructor(
    @inject(requestContainerToken) private requestContainer: DependencyContainer
  ) {}

  hover(elementOrElementGetter?: RefType | (() => RefType)): HoverEventBuilder {
    const hoverBuilder = this.requestContainer.resolve(HoverEventBuilder)
    elementOrElementGetter && hoverBuilder.setElement(elementOrElementGetter)
    return hoverBuilder
  }

  windowWidthResize(componentInstance?: Vue): WindowWidthResizeEventBuilder {
    const builder = this.requestContainer.resolve(WindowWidthResizeEventBuilder)
    componentInstance && builder.setComponent(componentInstance)
    return builder
  }
}
